import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-assistance-coverage-value',
  templateUrl: './assistance-coverage-value.component.html',
  styleUrls: ['./assistance-coverage-value.component.scss']
})
export class AssistanceCoverageValueComponent implements OnInit {

  @Input() value: string | boolean;
  @Input() isAmount: boolean = false;
  @Input() showRecommendation: boolean;
  icon: string;

  get highlightedImageSrc(): string {
    return 'assets/images/badge.svg';
  }

  constructor() {
  }

  ngOnInit() {
    if (typeof this.value === 'boolean') {
      this.icon = this.value ? 'check' : '—';
    }
  }
}
